import axios from 'axios';
import { AccumulatorChartDataList } from '../../interfaces/Accumulator';
import { getCsrftoken } from '../../helpers/csfrToken';
import { restErrorHandler } from '../../helpers/restErrorHandler';
import { DateRangeInterface } from '../Pickers/dataRange';
import { RestApiState } from './Organization';


export interface AcbOsProps {
    file?: string;
    file_name?: string;
    file_hash?: string;
}

export interface AcbOsPostProps {
    file: File;
}


export const fetchOsData = (serialNumber:string, role: string, setData: (value:any) => void):void => {
    axios.get<AcbOsProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/update-os`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var data: AcbOsProps = response.data
            setData(data)
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
    });

}


export const updateOsData = (serialNumber: string, role: string, data: any, statusSetter: (value: RestApiState) => void): void => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.post<AcbOsPostProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/update-os`, data , headers)
        .then(response => {
                if (response.status === 201) {
                    statusSetter(RestApiState.Success)
                }
            }
        )
        .catch(error => {
            console.error('Error fetching accumulator details:', error)
            if (error.response.status === 400) {
                statusSetter(RestApiState.BadRequest)
            } else if (error.response.status === 500) {
                statusSetter(RestApiState.ServerError)
            } else {
                statusSetter(RestApiState.Unknown)
            }
        });
}